export enum ContactType {
  BROKER = 'BROKER',
  BANK = 'BANK',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  INDIVIDUAL = 'INDIVIDUAL',
}

export enum LegalEntityContactAddressType {
  LEGAL = 'legal',
  OTHER = 'other',
}

export enum IndividualContactPhoneNumberType {
  MOBILE = 'mobile',
  WORK = 'work',
  HOME = 'home',
}

export enum IndividualContactEmailType {
  PERSONAL = 'personal',
  WORK = 'work',
}

export enum IndividualContactAddressType {
  PERSONAL = 'personal',
  WORK = 'work',
  HOME = 'home',
  OTHER = 'other',
}

export enum IndividualContactType {
  PERSONAL = 'personal',
  FINANCES = 'finances',
  BUSINESS = 'business',
  FAMILY = 'family',
  SOS = 'sos',
}

export enum IndividualContactRoleType {
  AssetProxy = 'asset_proxy',
  AssetManager = 'asset_manager',
  Service = 'service',
  Manager = 'manager',
  Advisor = 'advisor',
  Partner = 'partner',
  RegisteredOwner = 'registeredOwner',
  Other = 'other',
}

export enum IndividualContactUrgencyType {
  Urgent = 'urgent',
  Current = 'current',
}

export enum IndividualContactAccessGroundsType {
  Authority = 'authority',
  Agreement = 'agreement',
  PowerOfAttorney = 'power_of_attorney',
  Other = 'other',
}
